import React, { useContext } from 'react';
import { CreateUsernameFormContext } from 'src/Booking/components/CreateUsernameForm/CreateUsernameFormProvider';
import CreateUsernameFormView from 'src/Booking/components/CreateUsernameForm/CreateUsernameFormView';

/**
 *
 * @param {Object} props
 * @returns {JSX.Element}
 * @constructor
 */
const CreateUsernameFormContainer = (props) => {
    const formContext = useContext(CreateUsernameFormContext);
    return <CreateUsernameFormView {...props} {...formContext} />;
};

export default CreateUsernameFormContainer;
